<template>
  <div class="bg-white rounded-xl shadow-lg p-6">
    <h2 class="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
      <span>🚧</span>
      Análisis de Cuellos de Botella
    </h2>

    <!-- Principal Cuello -->
    <div class="bg-red-50 border-2 border-red-300 rounded-lg p-4 mb-6">
      <div class="flex items-center gap-3">
        <span class="text-3xl">⚠️</span>
        <div>
          <h3 class="font-semibold text-gray-900">Principal Cuello de Botella</h3>
          <p class="text-lg font-bold text-red-600 mt-1">
            {{ analisis.principal_cuello.etapa }}: {{ analisis.principal_cuello.cantidad }} productos
          </p>
        </div>
      </div>
    </div>

    <!-- Resumen de Cuellos -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-6">
      <div class="bg-gray-50 rounded-lg p-3 border border-gray-200">
        <p class="text-xs text-gray-600 mb-1">Sin Formato</p>
        <p class="text-2xl font-bold text-gray-900">{{ analisis.resumen.sin_formato }}</p>
      </div>
      <div class="bg-yellow-50 rounded-lg p-3 border border-yellow-200">
        <p class="text-xs text-gray-600 mb-1">Sin Aprobar</p>
        <p class="text-2xl font-bold text-yellow-600">{{ analisis.resumen.formato_sin_aprobar }}</p>
      </div>
      <div class="bg-orange-50 rounded-lg p-3 border border-orange-200">
        <p class="text-xs text-gray-600 mb-1">Sin Iniciar</p>
        <p class="text-2xl font-bold text-orange-600">{{ analisis.resumen.sin_iniciar_produccion }}</p>
      </div>
      <div class="bg-blue-50 rounded-lg p-3 border border-blue-200">
        <p class="text-xs text-gray-600 mb-1">En Proceso</p>
        <p class="text-2xl font-bold text-blue-600">{{ analisis.resumen.produccion_incompleta }}</p>
      </div>
      <div class="bg-red-50 rounded-lg p-3 border border-red-200">
        <p class="text-xs text-gray-600 mb-1">Sin Instalar</p>
        <p class="text-2xl font-bold text-red-600">{{ analisis.resumen.sin_instalar }}</p>
      </div>
    </div>

    <!-- Recomendaciones -->
    <div>
      <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>💡</span>
        Recomendaciones
      </h3>
      <div class="space-y-3">
        <div
          v-for="(recomendacion, index) in analisis.recomendaciones"
          :key="index"
          :class="getPrioridadClass(recomendacion.prioridad)"
          class="p-4 rounded-lg border-l-4"
        >
          <div class="flex items-start gap-3">
            <span class="text-2xl">{{ getPrioridadIcono(recomendacion.prioridad) }}</span>
            <div class="flex-1">
              <div class="flex items-center gap-2 mb-2">
                <span :class="getPrioridadBadgeClass(recomendacion.prioridad)" class="px-2 py-1 rounded-full text-xs font-semibold">
                  {{ recomendacion.prioridad }}
                </span>
                <span class="text-sm font-medium text-gray-700">{{ recomendacion.area }}</span>
              </div>
              <p class="text-sm text-gray-900">{{ recomendacion.mensaje }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CuellosBottella',
  props: {
    analisis: {
      type: Object,
      required: true
    }
  },
  methods: {
    getPrioridadClass(prioridad) {
      switch (prioridad) {
        case 'CRITICA':
          return 'bg-red-50 border-red-500';
        case 'ALTA':
          return 'bg-orange-50 border-orange-500';
        case 'MEDIA':
          return 'bg-yellow-50 border-yellow-500';
        case 'BAJA':
          return 'bg-green-50 border-green-500';
        default:
          return 'bg-gray-50 border-gray-300';
      }
    },
    getPrioridadBadgeClass(prioridad) {
      switch (prioridad) {
        case 'CRITICA':
          return 'bg-red-100 text-red-800';
        case 'ALTA':
          return 'bg-orange-100 text-orange-800';
        case 'MEDIA':
          return 'bg-yellow-100 text-yellow-800';
        case 'BAJA':
          return 'bg-green-100 text-green-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    },
    getPrioridadIcono(prioridad) {
      switch (prioridad) {
        case 'CRITICA':
          return '🔴';
        case 'ALTA':
          return '🟠';
        case 'MEDIA':
          return '🟡';
        case 'BAJA':
          return '🟢';
        default:
          return '⚪';
      }
    }
  }
};
</script>
